const TESTIMONIALS = [
  { id: "t-marcus", q: "Lending Loan USA closed my expansion facility in 36 hours. Every interaction felt private, professional and precise.", n: "Marcus H.", r: "Founder · Manhattan" },
  { id: "t-adaeze", q: "Their team treated my file with real discretion. The rate they offered was materially better than my prior bank.", n: "Adaeze O.", r: "Physician · Atlanta" },
  { id: "t-rebecca", q: "The application was elegant, the encryption was obvious, and the funds arrived when they said they would.", n: "Rebecca L.", r: "Architect · San Francisco" },
];

export default function TestimonialsSection() {
  return (
    <section className="border-y border-white/10 bg-[#0A1128] py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Voices</div>
        <h2 className="mt-4 font-serif text-4xl font-light sm:text-5xl">
          Trusted by clients who ask better questions.
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t) => (
            <blockquote
              key={t.id}
              className="relative border border-white/10 bg-white/[0.02] p-8"
              data-testid={`testimonial-${t.id}`}
            >
              <div className="absolute -top-4 left-8 bg-[#0A1128] px-3 font-serif text-5xl leading-none text-[#D4AF37]">
                “
              </div>
              <p className="mt-4 font-serif text-lg font-light leading-relaxed text-white/85">{t.q}</p>
              <footer className="mt-6 border-t border-white/10 pt-4">
                <div className="text-sm text-white">{t.n}</div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">{t.r}</div>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
